import HomeBlog from './HomeBlog'
import HomeIntro from './HomeIntro'
import HomeLife from './HomeLife'
import HomeProjects from './HomeProjects'
import HomeSocials from './HomeSocials'
import HomeTimeline from './HomeTimeline'

export {
  HomeBlog,
  HomeIntro,
  HomeLife,
  HomeProjects,
  HomeSocials,
  HomeTimeline,
}
